import React from 'react';

import { bind } from 'bind-decorator';

import { createStyles, withStyles } from '@material-ui/core';
import type { WithStyles } from '@material-ui/core';
import { MenuItem } from '@zinc/ui';

export const styles = createStyles({
  tabButton: {
    cursor: 'pointer'
  }
});

export interface IProps extends WithStyles<typeof styles> {
  label?: string;
  className?: string;
  onClick?: () => void;
}

class PageTab extends React.Component<IProps> {
  static readonly defaultProps: Partial<IProps> = {
    label: '',

    onClick: () => null
  };

  render() {
    const { label, classes, className } = this.props;

    return <MenuItem onClick={this.onClick}>{label}</MenuItem>;
  }

  @bind
  private onClick(): void {
    const { label, onClick } = this.props;
    if (label !== '|') {
      onClick!();
    }
  }
}

export default withStyles(styles)(PageTab);
